<template>
    <div class="search_nav">
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="场站大类（可多选）：">
                <el-select v-model="searchForm.stationTypes" multiple clearable placeholder="请选择" style="width: 180px;" collapse-tags collapse-tags-tooltip>
                    <el-option label="高速" :value="1"></el-option>
                    <el-option label="市区" :value="2"></el-option>
                    <el-option label="内部" :value="3"></el-option>
                    <!-- <el-option label="社区" :value="4"></el-option> -->
                </el-select>
            </el-form-item>
            <el-form-item label="场站（可多选）：">
                <el-select v-model="searchForm.stationIds" multiple filterable clearable placeholder="请选择场站" style="width: 200px;" collapse-tags collapse-tags-tooltip>
                    <el-option
                        v-for="item in stationOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="手机号：">
                <el-input v-model="searchForm.phoneNumber" placeholder="手机号" clearable style="width: 150px;"></el-input>
            </el-form-item>
            <el-form-item label="用户类型（可多选）：">
                <el-select v-model="searchForm.userTypes" multiple clearable placeholder="请选择" style="width: 180px;" collapse-tags collapse-tags-tooltip>
                    <el-option label="个人用户（预付费）" :value="0"></el-option>
                    <el-option label="个人用户（后付费）" :value="4"></el-option>
                    <el-option label="企业用户（预付费）" :value="1"></el-option>
                    <el-option label="企业用户（后付费）" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="付费模式：">
                <el-select v-model="searchForm.payMode" clearable placeholder="请选择" style="width: 150px;">
                    <el-option label="账户余额" :value="1"></el-option>
                    <el-option label="支付分" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="充电桩类型：">
                <el-select v-model="searchForm.pileType" clearable placeholder="请选择" style="width: 150px;">
                    <el-option label="交流" :value="1"></el-option>
                    <el-option label="直流" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="结算状态：">
                <el-select v-model="searchForm.settleStatus" clearable placeholder="请选择" style="width: 150px;">
                    <el-option label="未结算" :value="0"></el-option>
                    <el-option label="已结算" :value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单特性：">
                <el-select v-model="searchForm.orderFeature" clearable placeholder="请选择" style="width: 150px;">
                    <el-option label="正常订单" :value="1"></el-option>
                    <el-option label="跨月异常订单" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间范围：">
                <el-select v-model="searchForm.dateType" placeholder="请选择" style="width: 150px; margin-right: 8px;">
                    <el-option label="充电开始时间" :value="1"></el-option>
                    <el-option label="充电结束时间" :value="2"></el-option>
                    <el-option label="充电结算时间" :value="3"></el-option>
                </el-select>
                <el-date-picker
                    v-model="searchForm.dateRange"
                    type="datetimerange"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    style="width: 380px;"
                />
            </el-form-item>
            <el-form-item>
                <div class="button_group">
                    <el-button type="primary" @click="search">搜索</el-button>
                    <el-button type="primary" @click="refresh">刷新</el-button>
                    <el-button type="primary" @click="exportData">导出</el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>

    <div class="table-container">
        <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="充电订单编号" width="300" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.transactionId || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="场站大类" width="100">
            <template #default="scope">
                <span>{{ stationTypeFormat(scope.row.stationType) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="场站" width="250" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.stationName || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="手机号" width="120">
            <template #default="scope">
                <span>{{ scope.row.phoneNumber || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="用户类型" width="150">
            <template #default="scope">
                <span>{{ userTypeFormat(scope.row.userType) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="充电日期" width="120">
            <template #default="scope">
                <span>{{ scope.row.beginTime ? scope.row.beginTime.split(' ')[0] : '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="开始时间" width="170">
            <template #default="scope">
                <span>{{ scope.row.beginTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="结束时间" width="170">
            <template #default="scope">
                <span>{{ scope.row.endTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="充电电费" width="100">
            <template #default="scope">
                <span>{{ scope.row.elecFee != null ? scope.row.elecFee.toFixed(2) : '0.00' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="充电服务费" width="110">
            <template #default="scope">
                <span>{{ scope.row.svcFee != null ? scope.row.svcFee.toFixed(2) : '0.00' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="实付金额" width="100">
            <template #default="scope">
                <span>{{ scope.row.payAmt != null ? scope.row.payAmt.toFixed(2) : '0.00' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="充电时长" width="100">
            <template #default="scope">
                <span>{{ scope.row.duration || '0' }}分钟</span>
            </template>
        </el-table-column>
        <el-table-column label="充电量" width="100">
            <template #default="scope">
                <span>{{ scope.row.chargeQuantity != null && scope.row.chargeQuantity !== 0 ? scope.row.chargeQuantity.toFixed(4) : (scope.row.chargeQuantity === 0 ? '--' : '0.00') }}</span>
            </template>
        </el-table-column>
        <el-table-column label="尖时电量" width="100">
            <template #default="scope">
                <span>{{ scope.row.spikeElec != null && scope.row.spikeElec !== 0 ? scope.row.spikeElec.toFixed(4) : (scope.row.spikeElec === 0 ? '--' : '0.00') }}</span>
            </template>
        </el-table-column>
        <el-table-column label="峰时电量" width="100">
            <template #default="scope">
                <span>{{ scope.row.peakElec != null && scope.row.peakElec !== 0 ? scope.row.peakElec.toFixed(4) : (scope.row.peakElec === 0 ? '--' : '0.00') }}</span>
            </template>
        </el-table-column>
        <el-table-column label="平时电量" width="100">
            <template #default="scope">
                <span>{{ scope.row.flatElec != null && scope.row.flatElec !== 0 ? scope.row.flatElec.toFixed(4) : (scope.row.flatElec === 0 ? '--' : '0.00') }}</span>
            </template>
        </el-table-column>
        <el-table-column label="谷时电量" width="100">
            <template #default="scope">
                <span>{{ scope.row.valleyElec != null && scope.row.valleyElec !== 0 ? scope.row.valleyElec.toFixed(4) : (scope.row.valleyElec === 0 ? '--' : '0.00') }}</span>
            </template>
        </el-table-column>
        <el-table-column label="桩" width="180" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.pileNo || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="枪" width="60">
            <template #default="scope">
                <span>{{ scope.row.gunNo || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="折后服务费" width="110">
            <template #default="scope">
                <span>{{ scope.row.discSvcFee != null ? scope.row.discSvcFee.toFixed(2) : '0.00' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="充电桩类型" width="120">
            <template #default="scope">
                <span>{{ pileTypeFormat(scope.row.pileType) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="第三方订单号" width="180" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.thirdOrderNo || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="结算状态" width="100">
            <template #default="scope">
                <span>{{ settleStatusFormat(scope.row.settleStatus) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="结算时间" width="170">
            <template #default="scope">
                <span>{{ scope.row.settleTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="付费模式" width="100">
            <template #default="scope">
                <span>{{ payModeFormat(scope.row.payMode) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="订单特性" width="120">
            <template #default="scope">
                <span>{{ orderFeatureFormat(scope.row.normal) }}</span>
            </template>
        </el-table-column>
    </el-table>
    </div>

    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />
</template>

<script>
import { ElMessage } from 'element-plus';

export default {
    name: 'ChargeRecord',
    data() {
        return {
            searchForm: {
                stationTypes: [],
                stationIds: [],
                phoneNumber: '',
                userTypes: [],
                payMode: null,
                pileType: null,
                settleStatus: null,
                orderFeature: null,
                dateType: 2,
                dateRange: [],
            },
            tableData: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            stationOptions: [],
        }
    },
    mounted() {
        this.getList();
        this.getStationOptions();
    },
    watch: {
        '$store.state.stationList': {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.getStationOptions();
                }
            },
            immediate: true
        },
        'searchForm.stationTypes': {
            handler(newVal, oldVal) {
                // 如果选中项减少，清除对应类型的场站
                if (oldVal && oldVal.length > 0 && newVal && newVal.length < oldVal.length) {
                    const removedTypes = oldVal.filter(type => !newVal.includes(type));
                    const allStations = this.$store.state.stationList || [];
                    // 找出被移除类型对应的场站ID
                    const removedStationIds = allStations
                        .filter(station => removedTypes.includes(Number(station.type)))
                        .map(station => station.id);
                    // 从已选场站中清除这些ID
                    this.searchForm.stationIds = this.searchForm.stationIds.filter(id => !removedStationIds.includes(id));
                }
                this.getStationOptions();
            }
        }
    },
    methods: {
        getStationOptions() {
            const allStations = this.$store.state.stationList || [];
            if (this.searchForm.stationTypes && this.searchForm.stationTypes.length > 0) {
                this.stationOptions = allStations.filter(station =>
                    this.searchForm.stationTypes.includes(Number(station.type))
                    && Number(station.state) !== 1
                );
            } else {
                this.stationOptions = [];
            }
        },
        search() {
            this.currentPage = 1;
            this.getList();
        },
        refresh() {
            this.searchForm = {
                stationTypes: [],
                stationIds: [],
                phoneNumber: '',
                userTypes: [],
                payMode: null,
                pileType: null,
                settleStatus: null,
                orderFeature: null,
                dateType: 2,
                dateRange: [],
            };
            this.currentPage = 1;
            this.getList();
        },
        exportData() {
            let that = this;
            if (!that.validateDateRange()) {
                return;
            }
            let param = {};
            if (that.searchForm.stationTypes.length > 0) {
                param.stationTypes = that.searchForm.stationTypes;
            }
            if (that.searchForm.stationIds.length > 0) {
                param.stationIds = that.searchForm.stationIds;
            }
            if (that.searchForm.phoneNumber) {
                param.phoneNumber = that.searchForm.phoneNumber;
            }
            if (that.searchForm.userTypes.length > 0) {
                param.userTypes = that.searchForm.userTypes;
            }
            if (that.searchForm.payMode) {
                param.payMode = that.searchForm.payMode;
            }
            if (that.searchForm.pileType) {
                param.pileType = that.searchForm.pileType;
            }
            if (that.searchForm.settleStatus !== null && that.searchForm.settleStatus !== undefined && that.searchForm.settleStatus !== '') {
                param.settleStatus = that.searchForm.settleStatus;
            }
            if (that.searchForm.orderFeature) {
                param.orderFeature = that.searchForm.orderFeature;
            }
            if (that.searchForm.dateType) {
                param.dateType = that.searchForm.dateType;
            }
            if (that.searchForm.dateRange && that.searchForm.dateRange.length === 2) {
                param.startTime = that.searchForm.dateRange[0];
                param.endTime = that.searchForm.dateRange[1];
            }
            that.$axios.post("bi-server/charge/record/export", JSON.stringify(param), {responseType: 'blob'}).then(result => {
                // axios拦截器自动处理下载
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },
        getList() {
            let that = this;
            if (!that.validateDateRange()) {
                return;
            }
            let param = {
                page: that.currentPage,
                pageSize: that.pageSize,
            };
            if (that.searchForm.stationTypes.length > 0) {
                param.stationTypes = that.searchForm.stationTypes;
            }
            if (that.searchForm.stationIds.length > 0) {
                param.stationIds = that.searchForm.stationIds;
            }
            if (that.searchForm.phoneNumber) {
                param.phoneNumber = that.searchForm.phoneNumber;
            }
            if (that.searchForm.userTypes.length > 0) {
                param.userTypes = that.searchForm.userTypes;
            }
            if (that.searchForm.payMode) {
                param.payMode = that.searchForm.payMode;
            }
            if (that.searchForm.pileType) {
                param.pileType = that.searchForm.pileType;
            }
            if (that.searchForm.settleStatus !== null && that.searchForm.settleStatus !== undefined && that.searchForm.settleStatus !== '') {
                param.settleStatus = that.searchForm.settleStatus;
            }
            if (that.searchForm.orderFeature) {
                param.orderFeature = that.searchForm.orderFeature;
            }
            if (that.searchForm.dateType) {
                param.dateType = that.searchForm.dateType;
            }
            if (that.searchForm.dateRange && that.searchForm.dateRange.length === 2) {
                param.startTime = that.searchForm.dateRange[0];
                param.endTime = that.searchForm.dateRange[1];
            }
            that.$axios.post("bi-server/charge/record/page", JSON.stringify(param)).then(result => {
                if (result.code == 200) {
                    that.tableData = result.data.records;
                    that.total = result.data.total;
                }
            });
        },
        validateDateRange() {
            if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
                const start = new Date(this.searchForm.dateRange[0].replace(/-/g, '/'));
                const end = new Date(this.searchForm.dateRange[1].replace(/-/g, '/'));
                const maxEnd = new Date(start);
                maxEnd.setFullYear(maxEnd.getFullYear() + 1);
                if (end > maxEnd) {
                    ElMessage.warning('查询时间区间最长不能超过1年，请调整时间范围');
                    return false;
                }
            }
            return true;
        },
        userTypeFormat(type) {
            const typeMap = {
                0: '个人用户（预付费）',
                1: '企业用户（预付费）',
                2: '企业用户（后付费）',
                4: '个人用户（后付费）',
            };
            return typeMap[type] || '-';
        },
        stationTypeFormat(type) {
            const typeMap = {
                1: '高速',
                2: '市区',
                3: '内部',
            };
            return typeMap[type] || '-';
        },
        pileTypeFormat(type) {
            const typeMap = {
                1: '交流',
                2: '直流',
                3: '交直流一体',
                4: '无线',
                5: '充放电一体机',
            };
            return typeMap[type] || '-';
        },
        settleStatusFormat(state) {
            if (state === null || state === undefined || state === '') return '-';
            return Number(state) > 0 ? '已结算' : '未结算';
        },
        payModeFormat(mode) {
            const modeMap = {
                1: '账户余额',
                2: '支付分',
            };
            return modeMap[mode] || '-';
        },
        orderFeatureFormat(normal) {
            const featureMap = {
                0: '跨月异常订单',
                1: '正常订单',
            };
            return featureMap[normal] || '-';
        },
    }
}
</script>

<style lang="scss" scoped>
.search_nav {
    width: 100%;
    background: #f5f5f5;
    margin-bottom: 15px;
}
/* 全局搜索栏标签 96px 放不下"场站大类（可多选）："等长标签，放宽到 154px；
   带 .demo-form-inline 提高优先级，否则会被后注入的 global-search.css 同优先级规则压回 */
.search_nav .demo-form-inline :deep(.el-form-item__label) {
    width: 154px;
    min-width: 154px;
}
.button_group {
    display: flex;
    gap: 10px;
}
.table-container {
    width: 100%;
    overflow-x: auto;
}
</style>